<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitle" id="contents"><a id="page_9"></a><strong><span class="color-7AC39E">CONTENTS</span></strong></p>
<hr class="hrline"/>
<p class="toc"><strong><a class="nounder" href="#/xhtml/intro#intro">INTRODUCTION</a></strong></p>
<p class="toc-chap"><strong><a class="nounder" href="#/xhtml/ch01#ch01">1 SCARE TACTICS</a></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 ADVICE THAT STUCK</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 CRAZYTOWN</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 WISE WORDS</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 IT’S FUNNY BECAUSE IT’S TRUE</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 COACHES, MENTORS &amp; OTHER UNFORGETTABLES</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 THE SISTERS</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 DIFFERENT DRUMMERS</span></strong></p>
<p class="toc-chap"><strong><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 THE OLD STANDARDS</span></strong></p>
<p class="toc-chap1"><strong><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 OUCH!</span></strong></p>
<p class="toc-chap1"><strong><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 LIFE CHANGERS</span></strong></p>
<p class="toc-bm1"><strong><span class="nounder" href="#/xhtml/app01#app01" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></strong></p>
<p class="toc-bm"><strong><span class="nounder" href="#/xhtml/app02#app02" title="Link target outside of Sample">ABOUT THE AUTHOR</span></strong></p>
<p class="noindent"><a id="page_10"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?60dc72cf